/**
 * Official Solventum identity colours, plus the Filtek family's own
 * product coding: Supreme blue, Easy Match purple, Bulk green.
 *
 * The `on dark` values are the legible tints of those product colours used on
 * the deep green canvas — the solid brand values are kept for reference and
 * for use on light surfaces.
 */
export const brand = {
  /** Solventum primary green */
  green: '#05DD4D',
  /** Solventum deep green — the canvas */
  deep: '#01332B',
  /** Solventum secondary light blue */
  sky: '#A1D4FD',

  /** Filtek product colours as printed on pack */
  supremeSolid: '#0F62AB',
  easyMatchSolid: '#6E4A9E',
  bulkSolid: '#05DD4D',

  /** Family accents, tuned for the dark green canvas */
  supreme: '#A1D4FD',
  easyMatch: '#BFA3F0',
  bulk: '#05DD4D',
  /** The cousin — warmth rather than a product colour */
  warmer: '#F0B37E',

  ink: '#01332B',
  dim: '#8FAFA6',
  quiet: '#C2D8D0'
}
